<template>
    <div class="aba-formulario">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="vertical-flow">
            <div class="columns">
                <div
                    :class="[
                        situacaoAtendimento == 0 &&
                        permissao.create &&
                        !assFormularioGeralTabelaIntegracao &&
                        !formularioIntegracao
                            ? 'column is-10'
                            : situacaoAtendimento == 0 &&
                              permissao.create &&
                              !assFormularioGeralTabelaIntegracao &&
                              formularioIntegracao
                            ? 'column is-10'
                            : situacaoAtendimento == 0 &&
                              !formularioIntegracao &&
                              (permissao.create || assFormularioGeralTabelaIntegracao)
                            ? 'column is-10'
                            : 'column is-12',
                    ]"
                >
                    <search-bar :onSearch="debouncedOnSearch" tooltipLabel="msg-campo-busca-formulario" />
                </div>
                <div class="column is-2" v-if="situacaoAtendimento == 0 && !formularioIntegracao && permissao.create">
                    <button class="save-btn botao-acao" type="button" @click="$emit('mostrarFormAnswer')">
                        {{ $t("responder-formulario") }}
                    </button>
                </div>
            </div>

            <div class="registry-wrapper">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    class="data-table"
                    :data="assMotivoAtendimentoFormulario"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(field, index) in fields"
                        :key="index"
                        :field="field.key"
                        :width="field.width"
                        :label="field.key != 'excluir' ? $t(field.key) : ''"
                        :sortable="field.sortable"
                        :cell-class="field.cellClass"
                    >
                        <template v-slot="props">
                            <div 
                                v-if="field.key === 'label'"
                                class="bar" 
                                :class="[getSituacaoClass(props.row)]" 
                                v-tippy 
                                :title="$t(getSituacaoHint(props.row))"
                            />

                            <div v-if="field.key === 'codigo'">
                                {{ props.row.codigo }}
                            </div>

                            <div v-else-if="field.key === 'titulo'" @click="changeToFormAnswerPage(props.row)">
                                <a> {{ props.row.titulo }} </a>
                            </div>
                            <div v-else-if="field.key === 'data_hora_criacao'">
                                {{ $moment(props.row.data_hora_criacao).format("L LTS") }}
                            </div>
                        </template>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
        </div>
    </div>
</template>

<script>
import FormFormularioService from "@/services/FormFormularioService";
import ContainerLoader from "@/components/content/loader/ContainerLoader";

export default {
    components: {
        ContainerLoader,
    },
    props: {
        situacaoAtendimento: {
            type: Number,
            default: 0,
        },
        uuidFrom: {
            type: String,
            default: "",
        },
        idMotivoAtendimento: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            assFormularioGeralTabelaIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                "ASS_FORM_FORMULARIO_GERAL_TABELA"
            ),
            formularioIntegracao: this.$store.state.user.tabelasERPWebServer.includes("FORM_FORMULARIO"),
            assMotivoAtendimentoFormulario: [],

            fields: [
                { key: "label", width: 5, sortable: false, visible: true, cellClass: 'table-td-relative' },
                { key: "codigo", width: null, sortable: true, cellClass: null },
                { key: "titulo", width: null, sortable: true, cellClass: null },
                {
                    key: "data_hora_criacao",
                    width: 180,
                    sortable: true,
                    cellClass: null,
                },
            ],
            service: new FormFormularioService(this.$http, this.$router),
            permissao: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: "",
            column: "datahorainc",
            order: "desc",
            isSaving: false,
            delete: null,
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.hasPermissionAccess("vendas", "crm", "ven-atendimento");

        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "ven-atendimento" },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    methods: {
        changeToFormAnswerPage(formulario) {
            this.$emit("formulario", formulario);
        },

        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1) this.pagination.resetPagination = true;

            this.isLoading = true;

            this.service
                .findAllFormPreenchimento(
                    this.column, //column
                    this.order, //order
                    currentPage - 1, //page
                    this.pagination.perPage, //limit
                    this.idMotivoAtendimento, //idTabelaFrom
                    "crm_motivo_atendimento", //formFormularioGeralTabela
                    this.uuidFrom, //uuidTabelaFrom
                    "crm_atendimento", //formFormularioGeralTabela
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.assMotivoAtendimentoFormulario = value;
                    this.isEmpty = this.assMotivoAtendimentoFormulario.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-load");
                    console.error("Erro ao carregar formularios.");
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                    this.$emit('lengthFormularios', this.assMotivoAtendimentoFormulario.length);
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((item) => {
                return {
                    id: item.id,
                    codigo: item.idform_formularioerp,
                    titulo: item.titulo,
                    formRespostaCabecalhoUuid: item.formRespostaCabecalho.uuid,
                    data_hora_finalizacao: item.formRespostaCabecalho.data_hora_finalizacao,
                    situacaoFormRespostaCabecalho: item.formRespostaCabecalho.situacao,
                    idAtendimentoErp: item.crmAtendimento.idAtendimentoErp,
                    situacaoCrmAtendimento: item.crmAtendimento.situacao,
                    data_hora_criacao: item.formRespostaCabecalho.data_hora_criacao,
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        getSituacaoClass(row) {
            if (row.situacaoFormRespostaCabecalho === 0) {
                if (
                    row.situacaoFormRespostaCabecalho != 0 &&
                    row.crmAtendimento &&
                    row.crmAtendimento.situacao === 0
                ) {
                    return "bar-nao-finalizado";
                }
                return "bar-em-preenchimento";
            }

            return "bar-finalizado";
        },
        getSituacaoHint(row) {
            if (row.situacaoFormRespostaCabecalho === 0) {
                if (
                    row.situacaoFormRespostaCabecalho != 0 &&
                    row.crmAtendimento &&
                    row.crmAtendimento.situacao === 0
                ) {
                    return "nao-finalizado";
                }
                return "em-preenchimento";
            }

            return "finalizado";
        },
        navegaParaFormularioPerguntas(row) {
            this.$router.push({
                name: "NomeDaRotaParaDetalhes",
                params: { id: row.id },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-formulario {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    .bar {
        position: absolute;
        top: 5px;
        bottom: 5px;
        left: 5px;
        right: 5px;
        border-radius: 100px;
        width: 5px;
        min-height: 25px;
        &.bar-em-preenchimento {
            background-color: #fd5858;
        }
        &.bar-nao-finalizado {
            background-color: #ffb93f;
        }
        &.bar-finalizado {
            background-color: #84bd42;
        }
    }

    @media (max-width: 760px) {
        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
